import {useMemo} from 'react';
import {ActionHistory, CareTaskChangesHistory} from '../../../backend/interfaces/care-task';
import {useUsersInfoCache} from '../../../hooks/use-users-info-cache';

/**
 * Custom hook to cache user information from care task logs.
 */
export function useHistoryLogsUsersCache(
  history?: CareTaskChangesHistory[],
  legacyHistory?: ActionHistory[]
) {
  const userIds = useMemo(() => {
    let result = history?.map((item) => item.userAuthorId) || [];
    if (legacyHistory && legacyHistory.length > 0) {
      result = result.concat(legacyHistory.map((item) => item.userAuthorId));
    }

    return result;
  }, [history, legacyHistory]);

  return useUsersInfoCache(userIds);
}
